










import { Vue, Component } from 'vue-property-decorator';
import NDVBase from './NDVBase.vue';

@Component({
  components: { NDVBase },
})
export default class NDVPantalla extends Vue {}
